export const MODIFY = 'cv/device/MODIFY';
export const MODIFY_FAILED = 'cv/device/MODIFY_FAILED';
export const MODIFY_SUCCEEDED = 'cv/device/MODIFY_SUCCEEDED';
